import { render, staticRenderFns } from "./housekeepingDispatchManage.vue?vue&type=template&id=698ea96d&scoped=true"
import script from "./housekeepingDispatchManage.vue?vue&type=script&lang=js"
export * from "./housekeepingDispatchManage.vue?vue&type=script&lang=js"
import style0 from "./housekeepingDispatchManage.vue?vue&type=style&index=0&id=698ea96d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698ea96d",
  null
  
)

export default component.exports